//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  name: 'app',
  computed: {
    ...mapState(['cachedComponents'])
  }
}



// WEBPACK FOOTER //
// ./src/App.vue